import { Box } from '@mui/material'
import AcceptDashboardInvitationActionButton from './AcceptDashboardInvitationActionButton';
import RejectDashboardInvitationActionButton from './RejectDashboardInvitationActionButton';

interface Props {
    doctorId: number;
    refetch?: () => void;
}

export default function DashboardInvitationActionButtons(props: Props) {
    return (
        <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            gap={1}
        >
            <AcceptDashboardInvitationActionButton {...props} />
            <RejectDashboardInvitationActionButton {...props} />

        </Box>
    )
}
